import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpContentType, HttpHeaders, HttpMethod } from "../../common/api/http";
import { EntityIdObject, EntityObject } from "../../common/types";
import { CreateUpdateDocumentNode, DocumentNode, DocumentNodeTreeList } from "./types";

const CREATE_DOCUMENT_NODE = ApiRequestAdapter.create("/documents", HttpMethod.POST);
const UPLOAD_DOCUMENT_NODES = ApiRequestAdapter.create("/documents/upload", HttpMethod.POST);
const UPDATE_DOCUMENT_NODE = ApiRequestAdapter.create("/documents/{0}", HttpMethod.PUT);
const DELETE_DOCUMENT_NODE = ApiRequestAdapter.create("/documents/{0}", HttpMethod.DELETE);
const GET_DOCUMENT_NODE_TREE = ApiRequestAdapter.create("/documents/tree", HttpMethod.GET);
const DOWNLOAD_DOCUMENT_NODE = ApiRequestAdapter.create("/documents/{0}", HttpMethod.GET);

export const documentsApi = {
  createDocumentNode: (request: CreateUpdateDocumentNode): AxiosPromise<DocumentNode> => {
    return apiService.post(CREATE_DOCUMENT_NODE.url, request);
  },
  uploadDocumentNodes: (request: FormData): AxiosPromise<DocumentNode[]> => {
    return apiService.post(UPLOAD_DOCUMENT_NODES.url, request, {
      headers: { [HttpHeaders.CONTENT_TYPE]: HttpContentType.MULTIPART_FORM_DATA },
    });
  },
  updateDocumentNode: (request: EntityObject<CreateUpdateDocumentNode>): AxiosPromise<DocumentNode> => {
    return apiService.put(UPDATE_DOCUMENT_NODE.getParametrizedUrl(request.id), request.object);
  },
  deleteDocumentNode: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_DOCUMENT_NODE.getParametrizedUrl(request.id));
  },
  getDocumentNodeTree: (): AxiosPromise<DocumentNodeTreeList> => {
    return apiService.get(GET_DOCUMENT_NODE_TREE.url);
  },
  downloadDocumentNode: (request: EntityIdObject): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_DOCUMENT_NODE.getParametrizedUrl(request.id), { responseType: "blob" });
  },
};
